import { Route, Routes } from 'react-router';

import DocumentsOverview from './Overview';

export default function DocumentsRoutes() {
  return (
    <Routes>
      <Route index element={<DocumentsOverview />} />
    </Routes>
  );
}
